import { render, staticRenderFns } from "./businessDetailResource.vue?vue&type=template&id=7aede01a&scoped=true"
import script from "./businessDetailResource.vue?vue&type=script&lang=js"
export * from "./businessDetailResource.vue?vue&type=script&lang=js"
import style0 from "./businessDetailResource.vue?vue&type=style&index=0&id=7aede01a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aede01a",
  null
  
)

export default component.exports